import styled from 'styled-components'

export const FormModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: min(90vh, 900px);
  overflow: hidden;
`

export const FormModalHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 20px 20px 0;
`

export const FormModalIntro = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 4px;
  padding: 8px 20px 0;
`

export const FormModalBody = styled.div<{$gap?: string}>`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  row-gap: ${({$gap}) => $gap ?? '12px'};
  padding: 16px 20px;
`

export const FormModalFooter = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px 20px;
  background-color: white;
  border-top: 1px solid #eaecf0;
`
